import { OnboardingState } from './state';
import { onboardingInitialState } from './initial-state';
import { OnboardingActions } from './action-creators';
import * as actions from './actions';

export const onboardingReducer = (
  state: OnboardingState = onboardingInitialState,
  action: OnboardingActions
): OnboardingState => {
  switch (action.type) {
    case actions.CREATE_ONBOARDING_SUCCESS: {
      return {
        ...state,
        inProgress: true,
        onboarding: action.onboarding,
      };
    }

    default:
      return state;
  }
};
